module.exports = __webpack_public_path__ + "static/media/daynight-meter.a916a9bf.png";